import { comicCategories } from "@/mocks/comic";

export default function Categories() {
  return (
    <section id="categories" className="paper-bg">
      <div className="container-paper py-14 md:py-20">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.18em] text-primary-600">
              <i className="ri-price-tag-3-line text-sm leading-none" aria-hidden="true"></i>
              主题栏目
            </span>
            <h2 className="mt-3 font-display text-3xl text-foreground-950 md:text-4xl">
              六大方阵，各怀绝技
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-600">
              从风尘仆仆的冒险，到灯下低语的怪谈，按你的口味钻进对应的一摞旧刊，慢慢翻。
            </p>
          </div>
          <a
            href="#featured"
            className="inline-flex items-center gap-1.5 rounded-md border border-primary-300 bg-background-50 px-4 py-2.5 text-sm whitespace-nowrap text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
          >
            浏览全部
            <i className="ri-arrow-right-line text-base leading-none" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-5">
          {comicCategories.map((c) => (
            <a
              key={c.name}
              href="#featured"
              className="group relative overflow-hidden rounded-lg border border-background-300 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="halftone-light absolute inset-x-0 top-0 h-1.5"></div>
              <div className="flex items-start justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${c.icon} text-xl leading-none`} aria-hidden="true"></i>
                </span>
                <span className="rounded-full bg-background-200 px-2.5 py-1 text-[11px] text-foreground-500">
                  {c.count}
                </span>
              </div>
              <h3 className="mt-5 font-display text-xl text-foreground-950">{c.name}</h3>
              <p className="mt-0.5 text-[11px] uppercase tracking-[0.18em] text-foreground-400">
                {c.en}
              </p>
              <p className="mt-2.5 text-sm leading-6 text-foreground-600">{c.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
                进入栏目
                <i className="ri-arrow-right-line text-sm leading-none" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}